export default __webpack_public_path__ + "static/media/pre-course-img.df5de6b4.jpg";